/**
 * @fileoverview gRPC-Web generated client stub for api
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.24.2
// source: vehicle_stats_service.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as vehicle_stats_service_pb from './vehicle_stats_service_pb';
import * as trip_service_pb from './trip_service_pb';


export class VehicleStatsServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetVehicleMileageByDate = new grpcWeb.MethodDescriptor(
    '/api.VehicleStatsService/GetVehicleMileageByDate',
    grpcWeb.MethodType.UNARY,
    vehicle_stats_service_pb.GetVehicleMileageByDateRequest,
    vehicle_stats_service_pb.GetVehicleMileageByDateResponse,
    (request: vehicle_stats_service_pb.GetVehicleMileageByDateRequest) => {
      return request.serializeBinary();
    },
    vehicle_stats_service_pb.GetVehicleMileageByDateResponse.deserializeBinary
  );

  getVehicleMileageByDate(
    request: vehicle_stats_service_pb.GetVehicleMileageByDateRequest,
    metadata: grpcWeb.Metadata | null): Promise<vehicle_stats_service_pb.GetVehicleMileageByDateResponse>;

  getVehicleMileageByDate(
    request: vehicle_stats_service_pb.GetVehicleMileageByDateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: vehicle_stats_service_pb.GetVehicleMileageByDateResponse) => void): grpcWeb.ClientReadableStream<vehicle_stats_service_pb.GetVehicleMileageByDateResponse>;

  getVehicleMileageByDate(
    request: vehicle_stats_service_pb.GetVehicleMileageByDateRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: vehicle_stats_service_pb.GetVehicleMileageByDateResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.VehicleStatsService/GetVehicleMileageByDate',
        request,
        metadata || {},
        this.methodDescriptorGetVehicleMileageByDate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.VehicleStatsService/GetVehicleMileageByDate',
    request,
    metadata || {},
    this.methodDescriptorGetVehicleMileageByDate);
  }

  methodDescriptorGetLatestOdoValueByDate = new grpcWeb.MethodDescriptor(
    '/api.VehicleStatsService/GetLatestOdoValueByDate',
    grpcWeb.MethodType.UNARY,
    vehicle_stats_service_pb.GetLatestOdoValueByDateRequest,
    vehicle_stats_service_pb.GetLatestOdoValueByDateResponse,
    (request: vehicle_stats_service_pb.GetLatestOdoValueByDateRequest) => {
      return request.serializeBinary();
    },
    vehicle_stats_service_pb.GetLatestOdoValueByDateResponse.deserializeBinary
  );

  getLatestOdoValueByDate(
    request: vehicle_stats_service_pb.GetLatestOdoValueByDateRequest,
    metadata: grpcWeb.Metadata | null): Promise<vehicle_stats_service_pb.GetLatestOdoValueByDateResponse>;

  getLatestOdoValueByDate(
    request: vehicle_stats_service_pb.GetLatestOdoValueByDateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: vehicle_stats_service_pb.GetLatestOdoValueByDateResponse) => void): grpcWeb.ClientReadableStream<vehicle_stats_service_pb.GetLatestOdoValueByDateResponse>;

  getLatestOdoValueByDate(
    request: vehicle_stats_service_pb.GetLatestOdoValueByDateRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: vehicle_stats_service_pb.GetLatestOdoValueByDateResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.VehicleStatsService/GetLatestOdoValueByDate',
        request,
        metadata || {},
        this.methodDescriptorGetLatestOdoValueByDate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.VehicleStatsService/GetLatestOdoValueByDate',
    request,
    metadata || {},
    this.methodDescriptorGetLatestOdoValueByDate);
  }

  methodDescriptorGetVehicleTrips = new grpcWeb.MethodDescriptor(
    '/api.VehicleStatsService/GetVehicleTrips',
    grpcWeb.MethodType.UNARY,
    vehicle_stats_service_pb.GetVehicleTripsRequest,
    vehicle_stats_service_pb.GetVehicleTripsResponse,
    (request: vehicle_stats_service_pb.GetVehicleTripsRequest) => {
      return request.serializeBinary();
    },
    vehicle_stats_service_pb.GetVehicleTripsResponse.deserializeBinary
  );

  getVehicleTrips(
    request: vehicle_stats_service_pb.GetVehicleTripsRequest,
    metadata: grpcWeb.Metadata | null): Promise<vehicle_stats_service_pb.GetVehicleTripsResponse>;

  getVehicleTrips(
    request: vehicle_stats_service_pb.GetVehicleTripsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: vehicle_stats_service_pb.GetVehicleTripsResponse) => void): grpcWeb.ClientReadableStream<vehicle_stats_service_pb.GetVehicleTripsResponse>;

  getVehicleTrips(
    request: vehicle_stats_service_pb.GetVehicleTripsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: vehicle_stats_service_pb.GetVehicleTripsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.VehicleStatsService/GetVehicleTrips',
        request,
        metadata || {},
        this.methodDescriptorGetVehicleTrips,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.VehicleStatsService/GetVehicleTrips',
    request,
    metadata || {},
    this.methodDescriptorGetVehicleTrips);
  }

  methodDescriptorGetTripsCountAndTotalKmDriven = new grpcWeb.MethodDescriptor(
    '/api.VehicleStatsService/GetTripsCountAndTotalKmDriven',
    grpcWeb.MethodType.UNARY,
    vehicle_stats_service_pb.GetTripsCountAndTotalKmDrivenRequest,
    vehicle_stats_service_pb.GetTripsCountAndTotalKmDrivenResponse,
    (request: vehicle_stats_service_pb.GetTripsCountAndTotalKmDrivenRequest) => {
      return request.serializeBinary();
    },
    vehicle_stats_service_pb.GetTripsCountAndTotalKmDrivenResponse.deserializeBinary
  );

  getTripsCountAndTotalKmDriven(
    request: vehicle_stats_service_pb.GetTripsCountAndTotalKmDrivenRequest,
    metadata: grpcWeb.Metadata | null): Promise<vehicle_stats_service_pb.GetTripsCountAndTotalKmDrivenResponse>;

  getTripsCountAndTotalKmDriven(
    request: vehicle_stats_service_pb.GetTripsCountAndTotalKmDrivenRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: vehicle_stats_service_pb.GetTripsCountAndTotalKmDrivenResponse) => void): grpcWeb.ClientReadableStream<vehicle_stats_service_pb.GetTripsCountAndTotalKmDrivenResponse>;

  getTripsCountAndTotalKmDriven(
    request: vehicle_stats_service_pb.GetTripsCountAndTotalKmDrivenRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: vehicle_stats_service_pb.GetTripsCountAndTotalKmDrivenResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.VehicleStatsService/GetTripsCountAndTotalKmDriven',
        request,
        metadata || {},
        this.methodDescriptorGetTripsCountAndTotalKmDriven,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.VehicleStatsService/GetTripsCountAndTotalKmDriven',
    request,
    metadata || {},
    this.methodDescriptorGetTripsCountAndTotalKmDriven);
  }

  methodDescriptorGetUserTrips = new grpcWeb.MethodDescriptor(
    '/api.VehicleStatsService/GetUserTrips',
    grpcWeb.MethodType.UNARY,
    vehicle_stats_service_pb.GetUserTripsRequest,
    vehicle_stats_service_pb.GetUserTripsResponse,
    (request: vehicle_stats_service_pb.GetUserTripsRequest) => {
      return request.serializeBinary();
    },
    vehicle_stats_service_pb.GetUserTripsResponse.deserializeBinary
  );

  getUserTrips(
    request: vehicle_stats_service_pb.GetUserTripsRequest,
    metadata: grpcWeb.Metadata | null): Promise<vehicle_stats_service_pb.GetUserTripsResponse>;

  getUserTrips(
    request: vehicle_stats_service_pb.GetUserTripsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: vehicle_stats_service_pb.GetUserTripsResponse) => void): grpcWeb.ClientReadableStream<vehicle_stats_service_pb.GetUserTripsResponse>;

  getUserTrips(
    request: vehicle_stats_service_pb.GetUserTripsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: vehicle_stats_service_pb.GetUserTripsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.VehicleStatsService/GetUserTrips',
        request,
        metadata || {},
        this.methodDescriptorGetUserTrips,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.VehicleStatsService/GetUserTrips',
    request,
    metadata || {},
    this.methodDescriptorGetUserTrips);
  }

  methodDescriptorGetTripCoordinate = new grpcWeb.MethodDescriptor(
    '/api.VehicleStatsService/GetTripCoordinate',
    grpcWeb.MethodType.UNARY,
    vehicle_stats_service_pb.GetTripCoordinateRequest,
    trip_service_pb.GetTripCoordinateDataResponse,
    (request: vehicle_stats_service_pb.GetTripCoordinateRequest) => {
      return request.serializeBinary();
    },
    trip_service_pb.GetTripCoordinateDataResponse.deserializeBinary
  );

  getTripCoordinate(
    request: vehicle_stats_service_pb.GetTripCoordinateRequest,
    metadata: grpcWeb.Metadata | null): Promise<trip_service_pb.GetTripCoordinateDataResponse>;

  getTripCoordinate(
    request: vehicle_stats_service_pb.GetTripCoordinateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: trip_service_pb.GetTripCoordinateDataResponse) => void): grpcWeb.ClientReadableStream<trip_service_pb.GetTripCoordinateDataResponse>;

  getTripCoordinate(
    request: vehicle_stats_service_pb.GetTripCoordinateRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: trip_service_pb.GetTripCoordinateDataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.VehicleStatsService/GetTripCoordinate',
        request,
        metadata || {},
        this.methodDescriptorGetTripCoordinate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.VehicleStatsService/GetTripCoordinate',
    request,
    metadata || {},
    this.methodDescriptorGetTripCoordinate);
  }

  methodDescriptorGetUserTripSummary = new grpcWeb.MethodDescriptor(
    '/api.VehicleStatsService/GetUserTripSummary',
    grpcWeb.MethodType.UNARY,
    vehicle_stats_service_pb.GetUserTripSummaryRequest,
    vehicle_stats_service_pb.GetUserTripSummaryResponse,
    (request: vehicle_stats_service_pb.GetUserTripSummaryRequest) => {
      return request.serializeBinary();
    },
    vehicle_stats_service_pb.GetUserTripSummaryResponse.deserializeBinary
  );

  getUserTripSummary(
    request: vehicle_stats_service_pb.GetUserTripSummaryRequest,
    metadata: grpcWeb.Metadata | null): Promise<vehicle_stats_service_pb.GetUserTripSummaryResponse>;

  getUserTripSummary(
    request: vehicle_stats_service_pb.GetUserTripSummaryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: vehicle_stats_service_pb.GetUserTripSummaryResponse) => void): grpcWeb.ClientReadableStream<vehicle_stats_service_pb.GetUserTripSummaryResponse>;

  getUserTripSummary(
    request: vehicle_stats_service_pb.GetUserTripSummaryRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: vehicle_stats_service_pb.GetUserTripSummaryResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.VehicleStatsService/GetUserTripSummary',
        request,
        metadata || {},
        this.methodDescriptorGetUserTripSummary,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.VehicleStatsService/GetUserTripSummary',
    request,
    metadata || {},
    this.methodDescriptorGetUserTripSummary);
  }

}

